/* eslint-disable jsdoc/require-param-description */
import angular from 'angular';
import $ from 'jquery';
import _ from 'lodash-es';
import Tabulator from 'tabulator-tables';
import APIV5 from '~/models/api';
import Defaults from '~/scripts/constants/defaults';
import Utils from '~/scripts/services/utils';
import { ConfirmDeleteModal } from '~/utils/modals';
import { createWorkflowCell } from '~/components/ktable/columnFactory';
import Node from '~/scripts/services/model/node';
import {
	Breakpoints,
	MD_AND_UP,
	SM_AND_DOWN,
} from '~/services/breakpoints.service';

import templateModalBookmarkAdd from '~/components/bookmark/modal/modal-bookmark-add.html';
import ModalBookmarkAddController from '~/components/bookmark/modal/modal-bookmark-add.controller';
import { WFAffectSimpleModal } from '~/pages/dashboard/worflow-affect/workflow-affect';
import templateModalDuplicateDocument from '../modal/modal-list-duplicate-document.html';
import ModalListDuplicateDocumentController from '../modal/modal-list-duplicate-document.controller';
import templateModalListChangeClass from '../modal/modal-list-change-class.html';
import ModalListChangeClassController from '../modal/modal-list-change-class.controller';
import templateModalListPublish from '../modal/modal-list-publish.html';
import ModalListPublishController from '../modal/modal-list-publish.controller';
import templateModalListExport from '../modal/modal-list-export.html';
import ModalListExportController from '../modal/modal-list-export.controller';
import templateCellItemName from './list-cell-item-name.html';
import Lock from '~/scripts/services/model/lock';
import templateModalFormRepre from '~/components/repre/modals/modal-form-repre.html';
import ModalRepreFormController from '~/components/repre/modals/modal-form-repre.controller';

/* globals Knitiv */

/**
 * @typedef {import('@knitiv/api-client-javascript').ExtractResultRow & {
 *   edit: boolean,
 *   isaname: string,
 *   file_size: number,
 *   files: any[],
 *   loading: boolean,
 *   rename?: boolean,
 * }} RowData
 */

/**
 * @typedef {RowData & {
 *   node?: import('~/scripts/services/model/node').default,
 *   display: import('@knitiv/api-client-javascript').NodeRenameGetOutput['display'],
 *   info: import('@knitiv/api-client-javascript').NodeRenameGetOutput['info'],
 *   item_count?: number,
 *   rename: boolean,
 *   thumb_raw?: string,
 * }} RowDataItem
 */

const matchAny = (
	/** @type {any} */ data,
	/** @type {any} */ filterParameters,
) => {
	let match = false;

	const values = [
		data.name,
		data.isaname,
		data.datecreation?.toLocaleString('short'),
	];

	for (const value of values) {
		const name = value?.toLowerCase();

		if (name?.includes(filterParameters.value.toLowerCase())) {
			match = true;
		}
	}

	return match;
};

/* eslint-disable unicorn/no-null */
export default class ListResultsController {
	/* @ngInject */
	/**
	 * @param {import('angular').ICompileService} $compile
	 * @param {import('angular').IDocumentService} $document
	 * @param {import('angular').IFilterService} $filter
	 * @param {import('angular').ILocationService} $location
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').IScope} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 * @param {import('angular').IWindowService} $window
	 * @param {*} Agent
	 * @param {import('../../bookmark/bookmark.model').default} Bookmark
	 * @param {import('~/scripts/services/e-sign.service').default} ESignService
	 * @param {*} FileDownloadService
	 * @param {import('~/scripts/services/form.service').default} FormService
	 * @param {import('~/scripts/services/model/node-service').NodeService} NodeService
	 * @param {*} Notification
	 * @param {import('../../search-bar/search.factory').default} Search
	 * @param {import('angular').auto.IInjectorService} $injector
	 */
	constructor(
		$compile,
		$document,
		$filter,
		$location,
		$rootScope,
		$scope,
		$timeout,
		$translate,
		$uibModal,
		$window,
		Agent,
		Bookmark,
		ESignService,
		FileDownloadService,
		FormService,
		NodeService,
		Notification,
		Search,
		$injector,
	) {
		this.$compile = $compile;
		this.$document = $document;
		this.$filter = $filter;
		this.$location = $location;
		this.$rootScope = $rootScope;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$uibModal = $uibModal;
		this.$window = $window;
		this.Agent = Agent;
		this.Bookmark = Bookmark;
		this.ESignService = ESignService;
		this.FileDownloadService = FileDownloadService;
		this.FormService = FormService;
		this.NodeService = NodeService;
		this.Notification = Notification;
		this.Search = Search;
		this.$injector = $injector;

		/** @type {any} */
		this.class = {};

		/** @type {{ search: any, columns: any }} */
		this.filters = {
			search:  undefined,
			columns: {},
		};

		/** @type {boolean} */
		this.isAdminWF = this.$rootScope.context?.role?.mode === 'ADMIN_SUPER'
			|| this.$rootScope.context?.role?.sql_in.includes('K_NODE;KR_ADMIN_WF')
			|| false;

		/** @type {any} */
		this.item = undefined;

		/**
		 * @type {?RowDataItem}
		 */
		this.itemRenaming = null;

		this.listState = {
			display:     'list',
			elements:    0,
			files:       0,
			loading:     false,
			noSkeleton:  false,
			packetIndex: 1,
			packetSize:  100,
			sortExpr:    [],
			total:       0,
			wfCompleted: 0,
			wfProgress:  0,
			duration:    0,
		};

		/** @type {boolean} */
		this.loadingCount = false;

		/** @type {boolean} */
		this.overflow = false;

		/** @type {boolean} */
		this.countRowsExecuted = false;

		/** @type {?Tabulator} */
		this.table = null;

		/** @type {?Tabulator.Options} */
		this.options = {
			ajaxConfig:             {
				method:  'POST',
				headers: {
					'Content-type': 'application/json; charset=utf-8',
				},
			},
			ajaxLoaderError:        '<i class="fa fa-circle-o-notch fa-spin spinner"></i>',
			ajaxLoaderLoading:      '<i class="fa fa-circle-o-notch fa-spin spinner"></i>',
			ajaxRequestFunc:        (
				/** @type {string} */ url,
				/** @type {any} */ config,
				/** @type {any} */ parameters,
			) => this.extract(parameters),
			ajaxSorting:            false,
			ajaxURL:                `${APIV5.instance.backEndpoint}/api/v${Defaults.api.version}/Extract`,
			cellClick:              (/** @type {UIEvent} */ event, /** @type {Tabulator.CellComponent} */ cell) => {
				const data = cell.getRow().getData();
				const { field } = cell.getColumn().getDefinition();

				/** @type {string | undefined} */
				let tab;

				if (data.genre === 'group') {
					event.preventDefault();
					return;
				}

				// @ts-ignore
				if (data.rename || $(event.target).hasClass('dl-file')) {
					event.preventDefault();
					return;
				}

				if (field === 'wf') {
					tab = 'wf';
				}

				if (typeof data.event?.click === 'function') {
					data.event.click(event);
				}
				else {
					this.$timeout(async () => {
						if (!this.onContextMenu) {
							if (this.table?.getSelectedRows().length === 1) {
								await this.selectItem(
									event,
									this.table?.getSelectedRows()[0],
									tab,
								);
								this.$scope.$apply();
							}
							else {
								this.row = undefined;
							}
						}
					});
				}
			},
			dataTree: true,
			dataTreeBranchElement: false,
			dataTreeChildField: 'children',
			dataTreeExpandElement: "<i style=\"display: none\" class='fas fa-plus-circle'></i>",
			dataTreeCollapseElement: "<i style=\"display: none\" class='fas fa-minus-circle'></i>",
			dataTreeChildIndent: 12,
			height:                 '100%',
			index:                  'kid',
			layout:                 'fitColumns',
			movableColumns:         true,
			pageLoaded:             () => {
				this.listState.packetSize = this.table?.getPageSize() || 0;
			},
			pagination:             'remote',
			paginationSize:         this.listState.packetSize,
			paginationButtonCount:  5,
			paginationSizeSelector: [
				50,
				100,
				200,
				500,
			],
			placeholder: this.$translate.instant('list.no-results'),
			responsiveLayout: 'hide',
			rowContextMenu:         (/** @type {Tabulator.RowComponent} */ row) => {
				row.update({ rename: false });
				if (!row.isSelected()) {
					row.getTable().deselectRow();
					this.onContextMenu = true;
					row.select();
					this.$timeout(() => {
						this.onContextMenu = false;
					});
				}

				return this.getItemContextMenu(row);
			},
			// rowDblClick: () => {
			// 	if (clickBlockTimer) {
			// 		this.$timeout.cancel(clickBlockTimer);
			// 	}
			// },
			rowDeselected:          (/** @type {Tabulator.RowComponent} */ row) => {
				row.update({ rename: false });
				if (row === this.row) {
					this.row = undefined;
				}
				return this.$timeout(() => {
					if (this.table?.getSelectedRows().length === 0) {
						$('.kn-list').removeClass('item-preview');
						$location.search('selected', null);
					}
				});
			},
			selectable:             true,
			selectableRangeMode:    'click',
			tooltips:               false,
		};
		this.onContextMenu = false;

		/**
		 * @type {Tabulator.RowComponent | undefined}
		 */
		this.row = undefined;

		/**
		 * @type {string}
		 */
		this.search = '';

		/**
		 * @type {string | undefined}
		 */
		this.tab = undefined;

		/**
		 * @type {?Tabulator}
		 */
		this.table = null;

		this.isReady = false;
	}

	/**
	 * Returns the columns available for export, derived from the displayed table columns.
	 *
	 * @returns {{ field: string, title: string }[]} Available columns
	 */
	getExportColumns() {
		const columns = this.table?.getColumns() || [];
		return columns
			.map(column => column.getDefinition())
			.filter(definition => !!definition.field && !!definition.title)
			.map(definition => ({
				field: /** @type {string} */ (definition.field),
				title: /** @type {string} */ (definition.title),
			}));
	}

	/**
	 * Opens the export modal and performs the export based on the user choices.
	 *
	 * @param {Event} [event]
	 * @returns {Promise<void>}
	 */
	async openExportModal(event) {
		if (event) {
			// @ts-ignore
			angular.element(event.target).closest('.btn').trigger('blur');
		}

		const selectedRows = this.table?.getSelectedRows() || [];
		const selection = selectedRows.map(row => row.getData());

		try {
			const result = await this.$uibModal.open({
				ariaLabelledBy:  'modal-list-export-title',
				ariaDescribedBy: 'modal-list-export-body',
				template:        templateModalListExport,
				controller:      ModalListExportController,
				controllerAs:    '$ctrl',
				size:            'md',
				resolve:         {
					selection:    () => selection,
					columns:      () => this.getExportColumns(),
					hasSelection: () => selection.length > 0,
				},
			}).result;

			if (!result) {
				return;
			}

			this.exportToFile(result.format, result.scope === 'selection' ? selection : undefined);
		}
		catch (error) {
			if (error !== 'cancel' && error !== 'backdrop click' && error !== 'escape key press') {
				console.error(error);
			}
		}
	}

	/**
	 * Launches the file export through the Extract API.
	 *
	 * @param {string} format Export format (xlsx, csv, json)
	 * @param {any[]} [selection] Selected rows data (when exporting a selection)
	 */
	exportToFile(format, selection) {
		try {
			const kids = selection?.map(item => item.kid);
			const url = this.Search.extractExport(format, kids);

			window.open(url, '_self');

			this.$timeout(() => {
				this.$rootScope.$broadcast('List.exportedXLSX');
			}, 100); // cleanup
		}
		catch (error) {
			console.error(error);
			this.$rootScope.$broadcast('List.exportedXLSX');
		}
	}

	/**
	 * @param {PointerEvent} event
	 * @returns {Promise<any>}
	 */
	async bookmarkAdd(event) {
		// @ts-ignore
		angular.element(event.target).closest('.btn').trigger('blur');
		const bookmark = await this.$uibModal.open({
			ariaLabelledBy:  'modal-bookmark-add-title',
			ariaDescribedBy: 'modal-bookmark-add-body',
			template:        templateModalBookmarkAdd,
			controller:      ModalBookmarkAddController,
			controllerAs:    '$ctrl',
			size:            'sm',
			resolve:         {
				bookmark: () => ({
					data: {
						type:    this.Search.type?.kid,
						filters: this.Search.filters,
					},
					name: this.Search.type?.name,
				}),
			},
		}).result;

		const kid = bookmark.data.type;
		const { filters } = bookmark.data;
		return this.Bookmark.add(bookmark.name, {
			type: 'search',
			data: {
				filters,
				type: kid,
			},
		});
	}

	/**
	 * Download items
	 *
	 * @param {any[]} items
	 * @returns {Promise<void>}
	 */
	async download(items) {
		const result = await this.FileDownloadService.download(items, '_blank');
		if (result) {
			Utils.download(result.data, result.data.type, result.name, true);
		}
	}

	/**
	 * @param {any} item
	 * @param {Tabulator.RowComponent} row
	 */
	async changeClass(item, row) {
		const newIsa = await this.$uibModal.open({
			ariaDescribedBy: 'modal-list-change-class-body',
			ariaLabelledBy:  'modal-list-change-class-title',
			controller:      ModalListChangeClassController,
			controllerAs:    '$ctrl',
			resolve:         {
				item: () => item,
			},
			size:            'sm',
			template:        templateModalListChangeClass,
		}).result;

		if (newIsa) {
			await row.update({ new_isa: newIsa });
			await this.selectItem(null, row, 'form');
			if (this.row?.getData().kid === item.kid) {
				this.$timeout(() => {
					this.$rootScope.$broadcast('Form.set-new-isa', newIsa);
				});
			}
		}
	}

	formatTotal() {
		return new Intl.NumberFormat('fr-FR').format(this.listState.total);
	}

	formatExecTime() {
		if (this.listState.duration < 1) {
			return `${(this.listState.duration * 1000).toString() }ms`;
		}
		return `${this.listState.duration }s`;
	}

	isAdmin() {
		return this.$rootScope.context?.profil?.admin ?? 0;
	}

	/**
	 * @param {{ size: number, page: number }} parameters
	 * @returns {Promise<{
	 *   last_page: number | false,
	 *   data: import('@knitiv/api-client-javascript').ExtractResultRow[]
	 * }>}
	 */
	async extract(parameters) {
		const { size, page } = parameters;
		const packetSize = size;

		this.listState.packetIndex = (page - 1) * packetSize + 1;

		if (this.Search.type?.kid) {
			this.listState.loading = true;

			try {
				const data = await this.Search.extract(this.listState.packetIndex, packetSize);
				/** @type {any[]} */
				const list = [];
				let lastPage = 0;

				if (data && 'result' in data) {
					_.merge(this.class, data.result.class);
					if ((data.result.packet_index ?? 0) <= 1 && !this.countRowsExecuted) {
						this.listState.total = data.result.total;
					}
					this.listState.duration = data.result.duration;
					this.listState.noSkeleton = false;
					if (!this.countRowsExecuted && data.result.overflow) {
						this.overflow = true;
					}

					lastPage = Math.ceil(this.listState.total / packetSize);

					for (const row of data.result.rows) {
						this.setRow(row[0]);
						list.push(row[0]);
					}

					this.$timeout(async () => {
						this.listState.loading = false;

						const locationParameters = this.$location.search();

						// If only one item returned, then select it automatically
						if (list.length === 1) {
							const row = this.table?.getRow(list[0].kid);
							if (row) {
								// @ts-ignore
								this.table?.selectRow(row);
								await this.selectItem(null, row);
							}
						}

						else if (locationParameters.selected) {
							const row = this.table?.getRow(locationParameters.selected);
							if (row) {
								// @ts-ignore
								this.table?.selectRow(row);
								await this.selectItem(null, row);
							}
						}
					});
				}

				return {
					last_page: lastPage,
					data:      list,
				};
			}
			catch (/** @type {any} */ error) {
				console.error('Error fetching list data', error);

				this.$timeout(() => {
					this.table?.clearData();
					this.listState.total = 0;
					this.listState.loading = false;
					this.countRowsExecuted = false;
					this.listState.noSkeleton = error.errno === 'QUERY_FILTER_NO_SKELETON';
					return {
						last_page: false,
						data:      [],
					};
				});
			}
		}
		return {
			last_page: false,
			data:      [],
		};
	}

	async extractCount() {
		if (this.Search.type?.kid && !this.loadingCount) {
			this.loadingCount = true;
			const extractCount = await APIV5.instance.extractCount({
				extract: {
					enabled:    this.Search.enabled === null ? undefined : this.Search.enabled,
					filter:     this.Search.getFilters(),
					search_kid: this.Search.type.kid,
				},
			});
			if (extractCount) {
				this.$timeout(() => {
					this.listState.duration = extractCount.result.duration;
					this.listState.total = extractCount.result.total;
					this.countRowsExecuted = true;
					this.overflow = false;
					this.loadingCount = false;
				});
			}
		}
	}

	filterTable() {
		this.filters.search = this.search === '' ? undefined : {
			fn:     matchAny,
			params: { value: this.search },
		};

		this.updateFilters();
	}

	/**
	 * @param {Tabulator.RowComponent} row Row component
	 * @returns {*[]} Menu array
	 */
	getItemContextMenu(row) {
		const menu = [];

		const selectedRows = this.table?.getSelectedRows() || [];

		// if the item isn't a part of the selection, then unselect others
		if (!selectedRows.includes(row)) {
			this.table?.deselectRow();
			this.row = undefined;
		}

		const multiple = selectedRows.length > 1;

		/**
		 * @type {Tabulator.RowComponent[]}
		 */
		const selectedFiles = [];
		for (const selectedRow of selectedRows) {
			const item = selectedRow.getData();
			if (item.file === 1 || item.files?.length > 0) {
				selectedFiles.push(selectedRow);
			}
		}

		const item = { ...row.getData()};

		// Menu items
		const menuItems = {
			addToBookmarks:    {
				label:  `<i class="fa fa-star"></i> ${this.$translate.instant('list.add-bookmark')}`,
				action: () => {
					this.Bookmark.add(item.name, {
						type: 'node',
						data: {
							kid: item.kid,
						},
					});
					row.deselect();
				},
			},
			attenduNodeActive: {
				label:  `<i class="fa fa-check-circle"></i> Activer la conformité réglementaire`,
				action: async (/** @type {any} */ event, /** @type {Tabulator.RowComponent} */ currentRow) => {
					const currentSelectedRows = currentRow.getTable()?.getSelectedRows();
					await APIV5.instance.kattendu.nodeActive({ node_kid: currentSelectedRows.map(row2 => row2.getData().kid) });
					row.deselect();
				},
			},
			attenduNodeUnactive: {
				label:  `<i class="fa fa-times-circle"></i> Désactiver la conformité réglementaire`,
				action: async (/** @type {any} */ event, /** @type {Tabulator.RowComponent} */ currentRow) => {
					const currentSelectedRows = currentRow.getTable()?.getSelectedRows();
					await APIV5.instance.kattendu.nodeUnactive({ node_kid: currentSelectedRows.map(row2 => row2.getData().kid) });
					row.deselect();
				},
			},
			copyLinkPreview:   {
				label:  `<i class="fa fa-share-alt"></i> ${this.$translate.instant('form.copy-link-preview')}`,
				action: () => {
					const node = new Node(this.$injector, item.kid);
					node.copyLinkPreview();
				},
			},
			changeClass:       {
				label:    `<i class="fa fa-exchange"></i>
${this.$translate.instant('list.change-class')}`,
				disabled: () => (item.kright & Defaults.DROIT.MODIFY) === 0,
				action:   async () => {
					this.$timeout(() => this.changeClass(item, row));
				},
			},
			delete:            {
				label:    `<i class="fa fa-trash text-danger"></i>
${this.$translate.instant(multiple ? 'search.delete-selection' : 'common.delete')}`,
				disabled: (/** @type {any} */ selectedRow) => {
					let enabled = (item.kright & Defaults.DROIT.DELETE) > 0;

					for (const row2 of selectedRow.getTable().getSelectedRows()) {
						/** @type {import('@knitiv/api-client-javascript').ExtractResultRow} */
						const data = row2.getData();
						if (data.lock.locked && data.lock.profil.kid !== this.$rootScope.context?.profil.kid) {
							enabled = false;
						}
					}

					return !enabled;
				},
				action:   async (/** @type {any} */ event, /** @type {Tabulator.RowComponent} */ currentRow) => {
					let { name } = item;
					if (multiple) {
						name = this.$filter('sprintf')(
							this.$translate.instant('list.of-x-items'),
							this.table?.getSelectedRows().length,
						);
					}

					const modal = new ConfirmDeleteModal(this.$injector);
					const answer = await modal.open(name);
					const currentSelectedRows = currentRow.getTable()?.getSelectedRows();

					if (answer) {
						item.loading = true;
						const result = await this.NodeService.delete(
							currentSelectedRows.map(row2 => row2.getData().kid),
						);
						if (result) {
							item.loading = false;
							this.Notification.info({
								title:   this.$translate.instant('object.successfully-deleted-title'),
								message: this.$translate.instant('object.successfully-deleted-message'),
							});
							for (const selectedRow of currentSelectedRows) {
								selectedRow.delete();
							}
						}
					}
				},
			},
			download:          {
				label:  `<span> <i class="fa fa-download"></i> ${this.$translate
					.instant('common.download')} (${this.$filter('humanSize')(
					item.file_size ?? ('files' in item && item.files.length > 0 ? item.files[0].size : 0),
				)}) </span>`,
				disabled: () => (item.kright & Defaults.DROIT.READ) === 0,
				action: async () => {
					row.deselect();
					this.$timeout(() => this.download([item]));
				},
			},
			downloadSelection: {
				label:  `<i class="fa fa-download"></i> ${this.$filter('sprintf')(
					this.$translate.instant('search.download-selection'),
					selectedFiles.length,
					// eslint-disable-next-line unicorn/no-array-reduce
					this.$filter('humanSize')(selectedFiles.reduce((a, r) => (
						a + (r.getData().file_size ?? r.getData().files.reduce(
							(/** @type {number} */ b, /** @type {any} */ f) => (b + f.size),
							0,
						))
					), 0)),
				)}`,
				action: () => this.download(selectedFiles).then(() => this.table?.deselectRow()),
			},
			duplicate:         {
				label:    `<i class="fa fa-copy"></i> ${this.$translate.instant('list.duplicate-doc')}`,
				disabled: true,
				action:   async () => {
					const openDuplicateModal = async (
						/** @type {Node | import('~/scripts/services/model/form').default} */ node,
					) => {
						if (node) {
							item.node = node;
						}
						item.loading = false;

						const modalInstance = this.$uibModal.open({
							ariaDescribedBy: 'modal-list-duplicate-doc-body',
							ariaLabelledBy:  'modal-list-duplicate-doc-title',
							controller:      ModalListDuplicateDocumentController,
							controllerAs:    '$ctrl',
							resolve:         {
								name: () => item.node?.getName() ?? '',
							},
							size:            'sm',
							template:        templateModalDuplicateDocument,
						});

						const newName = await modalInstance.result;
						if (item.node) {
							item.node.setName(newName);
						}
						row.deselect();
						await this.NodeService.duplicate(item.node);
						await this.launchSearch();
					};

					if (item.node) {
						await openDuplicateModal();
					}
					else {
						item.loading = true;
						const node = await this.NodeService.load(item.kid);
						if (node) {
							await openDuplicateModal(node);
						}
					}
				},
			},
			exportSelection:   {
				label:  `<i class="fa fa-download"></i> ${this.$translate.instant('export.export-selection')}`,
				action: () => {
					this.$timeout(() => this.openExportModal());
				},
			},
			editDoc:           {
				label:    `<i class="fa fa-edit"></i> ${this.$translate.instant('list.open-with-agent')}`,
				disabled: this.Agent.status !== 'connected',
				action:   () => {
					this.Agent.openFile(item.kid);
					row.deselect();
				},
			},
			open:              {
				label:  `<i class="fa fa-search-plus"></i> ${this.$translate.instant('common.details')}`,
				disabled: () => (item.kright & Defaults.DROIT.READ) === 0,
				action: async () => {
					await this.selectItem(null, row, 'form');
					this.$scope.$apply();
				},
			},
			publish:           {
				label:  `<i class="fa fa-envelope"></i> ${this.$translate
					.instant(multiple ? 'search.publish-selection' : 'common.publish')}`,
				action: () => {
					this.publishItems(null, row.getTable().getSelectedRows()).then(() => this.table?.deselectRow()).catch(() => {
						this.table?.deselectRow();
					});
					this.$scope.$apply();
				},
			},
			readDoc:           {
				label:    `<i class="fa fa-eye"></i> ${this.$translate.instant('list.open-with-agent-readonly')}`,
				disabled: this.Agent.status !== 'connected',
				action:   () => {
					this.Agent.openFile(item.kid, true);
					row.deselect();
				},
			},
			rename:            {
				label:    `<i class="fa fa-pencil"></i> ${this.$translate.instant('common.rename')}`,
				disabled: (item.kright & Defaults.DROIT.MODIFY) === 0
					|| !((item.lock.locked && item.lock.profil.kid === this.$rootScope.context?.profil.kid) || !item.lock.locked)
					|| item.krepre_mode === 'NONE'
					|| item.renamable === false,
				action:   async (
					/** @type {any} */ event,
					/** @type {Tabulator.RowComponent} */ currentRow,
				) => {
					if (item.renamable) {
						for (const listRow of selectedRows) {
							if (listRow.getData().rename === true && currentRow !== listRow) {
								await listRow.update({ rename: false });
							}
						}

						try {
							const form = await this.FormService.loadRepre(item.kid);
							if (form) {
								const result = await this.$uibModal.open({
									ariaLabelledBy:  'modal-repre-title',
									ariaDescribedBy: 'modal-repre-body',
									template:        templateModalFormRepre,
									controller:      ModalRepreFormController,
									controllerAs:    '$ctrl',
									resolve:         {
										form: () => form.form,
										submission: () => form.submission,
									},
								}).result;

								if (result.submission) {
									const name = await this.FormService.updateRepre(form.form, result.submission.data);
									if (name) {
										row.update({ name });
									}
								}
							}
						}
						catch (error) {
							if (error !== 'cancel') {
								console.error(error);
							}
						}
					}
				},
			},
			sign:              {
				label:  `<i class="fa fa-pencil-square-o"></i> ${this.$translate.instant('list.sign')}`,
				action: async () => {
					await this.ESignService.create(item.kid);
				},
			},
			subscribe:         {
				label:  `<i class="fa fa-bullhorn"></i> ${this.$translate.instant('account.sub-to')} ${item.name}`,
				action: () => this.subscriptionSet(item.kid).then(() => {
					row.deselect();
					return this.$scope.$apply();
				}),
			},
			unlock:            {
				label:    `<i class="fa fa-unlock"></i> ${this.$translate.instant('common.unlock')}`,
				disabled: !(
					(
						this.item
							? (this.item.kid === item.kid && !this.item.edit) || this.item.kid !== item.kid
							: true
					)
					&& item.lock.locked
					&& (
						item.lock.profil.kid === this.$rootScope.context?.profil.kid
						|| this.$rootScope.context?.profil.admin
						|| this.$rootScope.hasCreatePermissions
					)
				),
				action:   async () => {
					await this.unlock(item);
					this.$scope.$apply();
				},
			},
			wf:                {
				label:  `<img class="fa" src="/images/workflow-icon.png" alt="W"> ${this.$translate.instant('list.workflows')}`,
				action: async () => {
					this.table?.deselectRow();
					await this.selectItem(null, row, 'wf');
					this.$scope.$apply();
				},
			},
			wf_abort: {
				label:  `<i class="fa fa-ban"></i>  ${this.$translate.instant('workflow.action-abort')}`,
				disabled: item.wf.length === 0,
				action: async (
					/** @type {any} */ _event,
					/** @type {import('tabulator-tables').RowComponent} */ currentRow,
				) => {
					await this.wfAbort(currentRow.getTable()?.getSelectedRows());
					this.$scope.$apply();
				},
			},
		};

		// Build menu
		if (multiple) {
			if (selectedFiles.length > 0) {
				menu.push(menuItems.downloadSelection);
			}
			menu.push(
				menuItems.publish,
				menuItems.exportSelection,
				{ separator: true },
				menuItems.delete,
				{ separator: true },
				menuItems.wf_abort,
			);
		}
		else {
			// Conditions sur KAttendu/NodeActive / KAttendu/NodeUnactive
			if (
				this.$rootScope.context?.db.sql_name === 'attest_reg'
				&& ['K_NODE;cREG', 'K_NODE;cSITE', 'K_NODE;cBAT', 'K_NODE;cEQPT'].includes(item.isa)
			) {
				menu.push(
					menuItems.attenduNodeActive,
					menuItems.attenduNodeUnactive,
					{ separator: true },
				)
			}
			if (this.$rootScope.context?.role.mode === 'ADMIN_SUPER'
				|| this.$rootScope.context?.role.mode === 'ADMIN_SYS') {
				menu.push(menuItems.changeClass);
			}
			menu.push(
				menuItems.duplicate,
			);
			if (item.file || ('files' in item && item.files?.length > 0)) {
				menu.push(
					{ separator: true },
					// menuItems.sign,
				);
			}
			if (item.krepre_mode !== 'NONE') {
				menu.push(menuItems.rename);
			}
			menu.push(menuItems.delete);
			if (item.file || ('files' in item && item.files?.length > 0)) {
				menu.push(menuItems.download);
			}
			if (item.lock.locked) {
				menu.push(menuItems.unlock);
			}
			menu.push(
				{ separator: true },
				menuItems.publish,
				menuItems.exportSelection,
				menuItems.addToBookmarks,
				menuItems.copyLinkPreview,
				{ separator: true },
				menuItems.open,
				// menuItems.subscribe,
				menuItems.wf,
			);

			if (this.isAdminWF) {
				menu.push(menuItems.wf_abort);
			}
		}

		return menu;
	}

	/**
	 * @param {boolean} [force]
	 * @returns {Promise<void>}
	 */
	async launchSearch(force = false) {
		if (this.listState.loading) {
			return;
		}

		if (this.Search.type) {
			this.listState.packetIndex = 1;
			this.$rootScope.showSearch = true;
			this.overflow = false;
			this.countRowsExecuted = false;
			this.table?.deselectRow();
			this.listState.files = 0;
			this.listState.elements = 0;
			if (force) {
				this.table?.setPage(1);
			}

			this.item = undefined;
			angular.element('.kn-list.resizable').css('flex-basis', '');
		}
	}

	/**
	 * @param {null} event
	 * @param {Tabulator.RowComponent[]} selectedRows
	 * @returns {import('angular').IPromise<any>}
	 */
	publishItems(event, selectedRows) {
		return this.$uibModal.open({
			ariaLabelledBy:  'modal-publish-title',
			ariaDescribedBy: 'modal-publish-body',
			template:        templateModalListPublish,
			controller:      ModalListPublishController,
			controllerAs:    '$ctrl',
			size:            'lg',
			resolve:         {
				items:   () => selectedRows.map(row2 => row2.getData()),
				options: {
					hideSubject: false,
				},
			},
			windowClass:     'modal-publish',
		}).result;
	}

	/**
	 * @param {KeyboardEvent} event
	 * @param {any} item
	 */
	renameItem(event, item) {
		if ((event.type === 'keyup' && event.key === 'Enter') || event.type === 'blur') {
			if (item.oldName !== item.name && item.oldName && item.name && !item.loading) {
				item.node.setName(item.name);
				item.loading = true;
				this.NodeService.update(item.node).then(() => {
					this.Notification.info({
						title:   this.$translate.instant('object.successfully-updated-title'),
						message: this.$translate.instant('object.successfully-updated-message'),
					});
					item.name = item.node.getName();
					item.rename = false;
					this.itemRenaming = null;
					item.loading = false;
					return item;
				}).catch(() => {
					item.name = item.oldName;
					item.node.setName(item.name);
					item.rename = false;
					this.itemRenaming = null;
				});
			}
			else {
				item.name = item.oldName;
				item.rename = false;
				this.itemRenaming = null;
			}
		}
	}

	/**
	 * @param {?Event} event JS Event
	 * @param {Tabulator.RowComponent} row RowComponent instance
	 * @param {string | undefined} [tab] Tab to open
	 */
	async selectItem(event, row, tab) {
		this.tab = tab;

		const data = row.getData();

		this.row = row;
		this.$location.search('selected', data.kid);
		this.$location.search('tab', this.tab || null);

		if (Breakpoints.is(SM_AND_DOWN)) {
			if (data.file === 1) {
				await this.download([data]);
			}
			else {
				let url = `/form/${data.kid}`;

				if (this.tab) {
					url += `?tab=${this.tab}`;
				}
				this.$location.url(url);

				// this.$scope.$emit('List.toggle-list', 'hidden');
			}
		}
		else {
			this.$scope.$emit('List.toggle-list', 'split');
		}
	}

	/** @param {string} display */
	setDisplay(display) {
		this.listState.display = display;
	}

	/**
	 * @param {any} row
	 */
	setRow(row) {
		if (row.datecreation === 'INFINITE') {
			row.datecreation = Number.POSITIVE_INFINITY;
		}
		else if (row.datecreation === '-INFINITE') {
			row.datecreation = Number.NEGATIVE_INFINITY;
		}
		else if (row.datecreation) {
			row.datecreation = new Date(row.datecreation);
		}
		if (row.file === 1) {
			this.listState.files++;
		}
		else {
			this.listState.elements++;
		}
		if (row.wf === 1) {
			this.listState.wfCompleted++;
		}
		else if (row.wf === 2) {
			this.listState.wfProgress++;
		}
		if (row.isa in this.class) {
			row.isaname = this.class[row.isa].name;
		}
	}

	/**
	 * @param {import('@knitiv/api-client-javascript').KNode} kid
	 */
	async subscriptionSet(kid) {
		await APIV5.instance.wfSubscriptionSet({ objnum: kid }, { id: 'list-results.subscription-set' });
	}

	updateFilters() {
		// set filter to active elements
		this.table?.clearFilter(true);

		// eslint-disable-next-line unicorn/no-array-for-each
		Object.entries(this.filters.columns).forEach(([field, matches]) => {
			// vvv wrong typings from library
			// @ts-ignore
			// noinspection JSCheckFunctionSignatures
			this.table?.addFilter(this.inArrayFilter.bind(this), {
				matches,
				field,
			});
		});

		if (this.filters.search) {
			// TODO à vérifier !
			// @ts-ignore
			this.table?.addFilter(this.filters.search.fn, this.filters.search.params);
		}
	}

	/**
	 * @param {any} item
	 */
	async unlock(item) {
		await this.NodeService.unlock(item);
		this.Notification.info({
			title:   this.$translate.instant('object.successfully-action-title'),
			message: this.$translate.instant('object.successfully-action-message'),
		});
		this.$timeout(() => {
			item.lock = new Lock();
		});
	}

	/**
	 * @param {import('tabulator-tables').RowComponent[]} rows
	 */
	async wfAbort(rows) {
		const modal = new WFAffectSimpleModal(this.$injector);

		/** @type {any[]} */
		const wfAffectKid = [];

		/** @type {any[]} */
		const items = rows.map(row2 => {
			const item = row2.getData();
			wfAffectKid.push(...item.wf.map((/** @type {any} */ w) => w.kid));
			return item;
		});

		const answer = await modal.open({
			onClick: async (/** @type {any} */ controller) => {
				// const actionKid = controller.currentAction.kid;

				await APIV5.instance.wfAffectAbort({
					wfaffect_kid: wfAffectKid,
					wfcomment: controller.comment,
				}, { id: 'list-results.wf-abort' });

				modal.close({ controller, type: 'success' });
			},
			onCancel: (/** @type {any} */ controller) => {
				modal.close({ controller, type: 'cancel' });
			},
			options: {
				modal: true,
				hideHistory: true,
				defaultAction: 'abort',
			},
			affectKid: wfAffectKid,
		});

		this.$timeout(() => {
			if (answer.type === 'success') {
				for (const item of items) {
					item.wf.length = 0;
					for (const row of rows) {
						if (row.getData().kid === item.kid) {
							row.update(item);
						}
					}
				}
				// I use this trick to recall custom formatter
				const table = rows[0].getTable();
				table.updateData(table.getData());
			}
			this.table?.deselectRow();
		});
	}

	init() {
		this.$location.search('return', null);
		this.$location.search('signKid', null);

		this.$rootScope.viewerDeployed = false;

		// @ts-ignore
		this.$document.on('keydown', (/** @type {KeyboardEvent} */ event) => {
			// F2: rename selected item
			if (this.table?.getSelectedRows().length === 1 && event.key === 'F2') {
				this.renameItem(event, this.table?.getSelectedRows()[0]);
			}

			// Escape: close contextmenu
			if (event.key === 'Escape') {
				this.$rootScope.$broadcast('List.closeContextMenu');
			}
		});

		this.$scope.$on('List.search', (event, force = false) => this.launchSearch(!!force));

		this.$scope.$on('List.setDisplay', (event, display) => {
			if (typeof display === 'string') {
				this.setDisplay(display);
			}
		});

		this.$scope.$on('$destroy', () => {
			this.$document.off('keydown');
		});

		this.$scope.$on('List.onExportXLSX', () => this.openExportModal());

		// select all items (Ctrl + A)
		angular.element(this.$window).bind('keydown', (/** @type {any} */ event) => {
			if (
				this.table
				&& this.table?.getRows().length > 0
				&& (event.ctrlKey || event.metaKey) && event.key === 'a'
				// @ts-ignore
				&& ![
					'INPUT',
					'TEXTAREA',
				].includes(event.target.tagName)
			) {
				event.preventDefault();
				this.table?.selectRow();
				this.row = undefined;
			}
		});

		// eslint-disable-next-line unicorn/consistent-function-scoping
		const isValidDate = (/** @type {any} */ dateObject) => new Date(dateObject).toString() !== 'Invalid Date';

		const dateCreationLongFormatter = (/** @type {Tabulator.CellComponent} */ cell) => {
			const div = document.createElement('div');

			const cellValue = cell.getValue();

			if (cellValue === Number.NEGATIVE_INFINITY) {
				div.textContent = '- ∞';
				return div;
			}

			if (cellValue === Number.POSITIVE_INFINITY) {
				div.textContent = '+ ∞';
				return div;
			}

			try {
				div.textContent = isValidDate(cellValue) ? new Intl.DateTimeFormat(
					this.$rootScope.context?.lang?.id,
					{ dateStyle: 'short', timeStyle: 'medium' },
				).format(cellValue) : cellValue;
			}
			catch (error) {
				console.error(error);
				div.textContent = cellValue;
			}
			return div;
		};

		const dateCreationShortFormatter = (/** @type {Tabulator.CellComponent} */ cell) => {
			const div = document.createElement('div');

			const cellValue = cell.getValue();

			if (cellValue === Number.NEGATIVE_INFINITY) {
				div.textContent = '- ∞';
				return div;
			}

			if (cellValue === Number.POSITIVE_INFINITY) {
				div.textContent = '+ ∞';
				return div;
			}

			div.textContent = isValidDate(cellValue) ? new Intl.DateTimeFormat(
				this.$rootScope.context?.lang?.id,
				{ dateStyle: 'short' },
			).format(cellValue) : cellValue;
			return div;
		};

		this.$timeout(() => {
			if (!this.table) {
				return;
			}
			this.table?.setColumns([
				{
					title:     this.$translate.instant('common.name'),
					field:     'name',
					widthGrow: 1,
					formatter: (cell, formatterParameters, onRendered) => {
						onRendered(() => {
							const cellElement = cell.getElement();

							/** @type {any} */
							const scope = this.$scope.$new();
							scope.cell = cell;
							scope.data = cell.getRow().getData();

							const newElement = this.$compile(templateCellItemName)(scope)[0];
							cellElement.append(newElement);
						});
						return '';
					},
				},
				{
					title:     this.$translate.instant('common.type'),
					field:     'isaname',
					formatter: cell => {
						const div = document.createElement('div');
						div.textContent = cell.getValue();
						return div;
					},
				},
				{
					title:     this.$translate.instant('common.active'),
					field:     'enabled',
					formatter: cell => {
						const element = `<i style="font-size: 13px" class="fa ${cell.getValue() === 'false'
							? 'fa-times-circle text-danger' : 'fa-check-circle text-success'}"></i>`;
						return this.$compile(element)(this.$scope)[0];
					},
					headerSort: false,
					hozAlign:   'center',
					maxWidth:   32,
				},
				{
					title:     this.$translate.instant('common.date'),
					field:     'datecreation',
					formatter: dateCreationLongFormatter,
					sorter:    'alphanum',
					maxWidth:  128,
				},
				// @ts-ignore
				createWorkflowCell(
					{
						field:    'wf',
						title:    'WF',
						maxWidth: 65,
					},
					this.$translate,
					this.$scope.$new(true),
					this.$compile,
				),
			]);

			const mdAndUpBP = Breakpoints.create(MD_AND_UP);
			// const smAndDownBP = Breakpoints.create(SM_AND_DOWN)

			const toggleWorkflowColumn = () => {
				if (mdAndUpBP.matches === true) {
					this.table?.showColumn('wf');
					// @ts-ignore
					this.table?.updateColumnDefinition('datecreation', {
						width:     undefined,
						formatter: dateCreationLongFormatter,
					});
					// @ts-ignore
					this.table?.updateColumnDefinition('name', {
						widthGrow: undefined,
					});
				}
				else {
					this.table?.hideColumn('wf');
					// @ts-ignore
					this.table?.updateColumnDefinition('datecreation', {
						width:     '70px',
						formatter: dateCreationShortFormatter,
					});
					// @ts-ignore
					this.table?.updateColumnDefinition('name', {
						widthGrow: 2,
					});
				}
			};

			toggleWorkflowColumn();

			mdAndUpBP.addEventListener('change', () => {
				toggleWorkflowColumn();
			});
		});
	}

	$onInit() {
		this.$scope.$on('$locationChangeSuccess', async (event, nUrl, oUrl) => {
			if (nUrl !== oUrl) {
				const newUrl = typeof nUrl === 'string' ? new URL(nUrl) : null;
				const oldUrl = typeof oUrl === 'string' ? new URL(oUrl) : null;
				const newFilter = JSON.parse(newUrl?.searchParams.get('filter') || '{}');
				const oldFilter = JSON.parse(oldUrl?.searchParams.get('filter') || '{}');
				if (newUrl?.pathname !== oldUrl?.pathname || !_.isEqual(newFilter, oldFilter)) {
					await this.launchSearch();
				}
			}
		});
		this.$rootScope.$on('Search.onReady', () => {
			if (!this.isReady) {
				this.isReady = true;
				this.init();
			}
		});
	}
}
